import { DataActionTypes } from "../actions/actiontypes";


export const setPasswordVisibility=(value)=>{
    return{
        type:DataActionTypes.set_Password_Visibility,
        payload:value
    }
}